import axios from 'axios';
import Cookies from 'js-cookie';

const api = axios.create({
    baseURL: process.env.NEXT_PUBLIC_API_URL || 'http://localhost:8001/api/v1',
    paramsSerializer: {
        indexes: null, // This makes axios send array params as: param=value1&param=value2 instead of param[]=value1
    },
});

api.interceptors.request.use(
    (config) => {
        const token = Cookies.get('auth_token');
        if (token) {
            config.headers.Authorization = `Bearer ${token}`;
            console.debug(`[AXIOS] ${config.method?.toUpperCase()} ${config.url} | Token present: YES (${token.length} chars)`);
        } else {
            console.warn(`[AXIOS] ${config.method?.toUpperCase()} ${config.url} | Token present: NO (cookie missing!)`);
        }
        return config;
    },
    (error) => {
        return Promise.reject(error);
    }
);

api.interceptors.response.use(
    (response) => response,
    (error) => {
        const status = error.response?.status;
        const url = error.config?.url;
        if (status === 401) {
            console.error(`[AXIOS] ${status} on ${url} | Token missing or expired.`);

            // Clear the token and redirect to login
            Cookies.remove('auth_token');
            if (typeof window !== 'undefined' && !window.location.pathname.includes('/login')) {
                window.location.href = '/login?session_expired=true';
            }
        } else if (status === 403) {
            console.error(`[AXIOS] 403 on ${url} | Insufficient permissions.`);
        }
        return Promise.reject(error);
    }
);

export default api;
